<template>
    <div class="entry_images">
        <form action="" method="post" enctype="multipart/form-data"
            :class="entry_uuid + 'entry_title_photo entry_title_photo mt-1'">
            <input type="file" name="file" class="files" :data-fileuploader-files='preload_file' />
        </form>
        <form action="" method="post" enctype="multipart/form-data"
            :class="entry_uuid + 'entry_title_photo_mobile  entry_title_photo_mobile mt-2'">
            <input type="file" name="file_mobile" class="files" :data-fileuploader-files='preload_file_mobile' />
        </form>
    </div>
</template>

<script>
    export default {
        props: ['preloadedentrytitlephoto', 'preloadedentrytitlephoto_mobile', 'entry_uuid', 'copy_preloadfiles',
            'copy_preloadfiles_mobile', 'copied_files'
        ],
        data() {
            return {
                file: [],
                file_mobile: [],
                preload_file: null,
                preload_file_mobile: null,
                string_files_mobile: "",
                string_files: "",
                file_count: 0,
            }
        },
        methods: {
            removeAllFiles() {
                for (var i = 0; i < this.file.length; i++) {
                    if (this.file[i].appended) {
                        axios.post('/api/offers/offer/entryTitle/remove', {
                            item: this.file[i],
                            entry_uuid: this.entry_uuid,
                            mobile_version: 0
                        }).then(response => {})
                    } else {
                        const fd = new FormData();
                        fd.append('file', this.file[i].file);
                        fd.append('entry_uuid', this.entry_uuid);
                        fd.append('mobile_version', 0);
                        axios.post('/api/offers/offer/entryTitle/remove', fd).then(response => {})
                    }
                }
                for (var i = 0; i < this.file_mobile.length; i++) {
                    if (this.file_mobile[i].appended) {
                        axios.post('/api/offers/offer/entryTitle/remove', {
                            item: this.file_mobile[i],
                            entry_uuid: this.entry_uuid,
                            mobile_version: 1
                        }).then(response => {})
                    } else {
                        const fd = new FormData();
                        fd.append('file', this.file_mobile[i].file);
                        fd.append('entry_uuid', this.entry_uuid);
                        fd.append('mobile_version', 1);
                        axios.post('/api/offers/offer/entryTitle/remove', fd).then(response => {})
                    }
                }
                this.file = []
                this.file_mobile = []
                this.preload_file = null
                this.preload_file_mobile = null
            },
            init() {
                if (this.preloadedentrytitlephoto && this.preloadedentrytitlephoto.length > 0) {
                    this.preload_file = JSON.stringify(this.preloadedentrytitlephoto)
                }
                if (this.preloadedentrytitlephoto_mobile && this.preloadedentrytitlephoto_mobile.length > 0) {
                    this.preload_file_mobile = JSON.stringify(this.preloadedentrytitlephoto_mobile)
                }
                if (this.copy_preloadfiles && this.copy_preloadfiles.length > 0) {
                    this.preload_file = JSON.stringify(this.copy_preloadfiles)
                }
                if (this.copy_preloadfiles_mobile && this.copy_preloadfiles_mobile.length > 0) {
                    this.preload_file_mobile = JSON.stringify(this.copy_preloadfiles_mobile)
                }
            }
        },
        mounted() {
            this.init()
        },
        created() {
            this.init()
            var t = this
            $(document).ready(function() {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $("." + t.entry_uuid + "entry_title_photo_mobile input.files").fileuploader({
                    limit: 1,
                    extensions: ['jpeg', 'jpg', 'png', 'svg'],
                    fileMaxSize: 2,
                    changeInput: '<div class="fileuploader-input">' +
                        t.$t('offer.title_photo_mobile_label') +
                        '<div class="fileuploader-input-inner">' +
                        '<div class="fileuploader-icon-main"></div>' +
                        '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                        "<p>${captions.or}</p>" +
                        "</div>" +
                        "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        item: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        item2: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        onImageLoaded: function(item) {
                            if (item.appended) {
                                t.file_mobile.push(item)
                                if (t.copied_files) {
                                    item.html.find('.column-title span').html(t.$t('offer.uploading'));
                                    const fd = new FormData();
                                    fd.append('file', item.file);
                                    fd.append('entry_uuid', t.entry_uuid);
                                    fd.append('mobile_version', 1);
                                    fd.append('similar', 1);
                                    axios.post('/api/offers/offer/entryTitle/save', fd).then(
                                        response => {
                                            item.html.find('.column-title span').html(item
                                                .size2);
                                            t.file_mobile.push(item)
                                            t.string_files_mobile = response.data
                                        })
                                }
                            } else {
                                item.html.find('.column-title span').html(t.$t('offer.uploading'));
                                const fd = new FormData();
                                fd.append('file', item.file);
                                fd.append('entry_uuid', t.entry_uuid);
                                fd.append('mobile_version', 1);
                                axios.post('/api/offers/offer/entryTitle/save', fd).then(
                                    response => {
                                        item.html.find('.column-title span').html(item.size2);
                                        t.file_mobile.push(item)
                                        t.string_files_mobile = response.data
                                    })
                            }
                            if (item.data.thumbnail) {
                                item.html.find('.fileuploader-no-thumbnail').html('<img src="' +
                                    item.data.thumbnail +
                                    '" style="width: 36px; height: 36px; object-fit: cover;" />'
                                );
                            }
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('offer.upload_img_feedback'),
                        feedback2: t.$t('offer.upload_img_feedback'),
                        drop: t.$t('offer.upload_img_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.img_remove'),
                        download: t.$t('offer.img_download'),
                        removeConfirmation: t.$t('offer.img_remove_confirm'),
                        errors: {
                            filesLimit: function(e) {
                                t.$toast.warning(
                                    t.$t('offer.img_only_one'), {
                                        timeout: 5000,
                                    })
                            },
                            filesType: function(e) {
                                t.$toast.warning("Obrázok tohto typu nemôže byť nahratý.", {
                                    timeout: 5000,
                                })
                            },
                            fileSize: function(e) {
                                t.$toast.warning(e.name +
                                    t.$t('offer.img_too_large_suffix') +
                                    e.fileMaxSize + " MB.", {
                                        timeout: 5000,
                                    })
                            }
                        }
                    }),
                    onRemove: function(item) {
                        item.html.find('.column-title span').html('Odstranenie...');
                        if (item.appended) {
                            axios.post('/api/offers/offer/entryTitle/remove', {
                                item: item,
                                entry_uuid: t.entry_uuid,
                                mobile_version: 1
                            }).then(response => {
                                t.file_mobile = [];
                            })
                        } else {
                            const fd = new FormData();
                            fd.append('file', item.file);
                            fd.append('entry_uuid', t.entry_uuid);
                            fd.append('mobile_version', 1);
                            axios.post('/api/offers/offer/entryTitle/remove', fd).then(response => {
                                t.file_mobile = [];
                            })
                        }
                    },

                });
                $("." + t.entry_uuid + "entry_title_photo input.files").fileuploader({
                    limit: 1,
                    extensions: ['jpeg', 'jpg', 'png', 'svg'],
                    fileMaxSize: 2,
                    changeInput: '<div class="fileuploader-input">' +
                        t.$t('offer.title_photo_desktop_label') +
                        '<div class="fileuploader-input-inner">' +
                        '<div class="fileuploader-icon-main"></div>' +
                        '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                        "<p>${captions.or}</p>" +
                        "</div>" +
                        "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        item: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        item2: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        onImageLoaded: function(item) {
                            if (item.appended) {
                                t.file.push(item)
                                if (t.copied_files) {
                                    item.html.find('.column-title span').html(t.$t('offer.uploading'));
                                    const fd = new FormData();
                                    fd.append('file', item.file);
                                    fd.append('entry_uuid', t.entry_uuid);
                                    fd.append('mobile_version', 0);
                                    fd.append('similar', 1);
                                    axios.post('/api/offers/offer/entryTitle/save', fd).then(
                                        response => {
                                            item.html.find('.column-title span').html(item
                                                .size2);
                                            t.file.push(item)
                                            t.string_files = response.data
                                        })
                                }
                            } else {
                                item.html.find('.column-title span').html(t.$t('offer.uploading'));
                                const fd = new FormData();
                                fd.append('file', item.file);
                                fd.append('entry_uuid', t.entry_uuid);
                                fd.append('mobile_version', 0);
                                axios.post('/api/offers/offer/entryTitle/save', fd).then(
                                    response => {
                                        item.html.find('.column-title span').html(item.size2);
                                        t.file.push(item)
                                        t.string_files = response.data
                                    })
                            }
                            if (item.data.thumbnail) {
                                item.html.find('.fileuploader-no-thumbnail').html('<img src="' +
                                    item.data.thumbnail +
                                    '" style="width: 36px; height: 36px; object-fit: cover;" />'
                                );
                            }
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('offer.upload_img_feedback'),
                        feedback2: t.$t('offer.upload_img_feedback'),
                        drop: t.$t('offer.upload_img_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.img_remove'),
                        download: t.$t('offer.img_download'),
                        removeConfirmation: t.$t('offer.img_remove_confirm'),
                        errors: {
                            filesLimit: function(e) {
                                t.$toast.warning(
                                    t.$t('offer.img_only_one'), {
                                        timeout: 5000,
                                    })
                            },
                            filesType: function(e) {
                                t.$toast.warning("Obrázok tohto typu nemôže byť nahratý.", {
                                    timeout: 5000,
                                })
                            },
                            fileSize: function(e) {
                                t.$toast.warning(e.name +
                                    t.$t('offer.img_too_large_suffix') +
                                    e.fileMaxSize + " MB.", {
                                        timeout: 5000,
                                    })
                            }
                        }
                    }),
                    onRemove: function(item) {
                        item.html.find('.column-title span').html('Odstranenie...');
                        if (item.appended) {
                            axios.post('/api/offers/offer/entryTitle/remove', {
                                item: item,
                                entry_uuid: t.entry_uuid,
                                mobile_version: 0
                            }).then(response => {
                                t.file = [];
                            })
                        } else {
                            const fd = new FormData();
                            fd.append('file', item.file);
                            fd.append('entry_uuid', t.entry_uuid);
                            fd.append('mobile_version', 0);
                            axios.post('/api/offers/offer/entryTitle/remove', fd).then(response => {
                                t.file = [];
                            })
                        }
                    },

                });
            })
        },
        watch: {
            preloadedentrytitlephoto: function() {
                this.init()
            },
            preloadedentrytitlephoto_mobile: function() {
                this.init()
            },
            copy_preloadfiles: function() {
                this.init()
            },
            copy_preloadfiles_mobile: function() {
                this.init()
            },
            string_files: function() {
                this.$emit('sendfile', this.string_files)
            },
            string_files_mobile: function() {
                this.$emit('sendfile_mobile', this.string_files_mobile)
            }
        },
    }
</script>

<style lang="scss">
    .pridat_obrazky_text {
        background-color: #fff;
        width: fit-content;
        padding: 0 10px;
        height: 40px;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 15px;
        text-align: center;
        color: #212541;
        display: flex;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border: 0;
        border-bottom-width: 0px;
        border-bottom-style: none;
        border-bottom-color: currentcolor;
        border-bottom: 2px solid #fff;

        &.active {
            border-bottom: 2px solid #2ed8b6;
        }

        box-shadow: 0px 1px 1px 0px #00000024;
    }

    .entry_title_photo,
    .entry_title_photo_mobile {
        width: 500px !important;

        .fileuploader {
            background: transparent;
            margin: 0;
            padding: 0;
        }

        .fileuploader-theme-dragdrop .fileuploader-input {
            position: relative;
            border: 1px dashed #DDE3E8;
            padding: 15px;
            height: 91px;

            .top_left {
                position: absolute;
                left: 15px;
                top: 15px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 11px;
                line-height: 13px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
            }

            .fileuploader-input-inner {
                margin-top: 14px;
                height: 100%;
                display: flex;
                align-items: center;
            }
        }

        .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main {
            margin: 0;
            font-size: 32px;
        }

        h3.fileuploader-input-caption {
            margin: 0;
            display: block;
            flex: none;
            align-self: center;
            margin-left: 10px;
            font-family: Roboto;
            font-style: normal;
            font-size: 14px;
            line-height: 16px;

            span {
                font-weight: normal;
                color: #263544;
            }

            .nahraj {
                font-weight: 600;
                color: #2ED8B6;
                text-decoration: underline;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .entry_images {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .noPremium {
        margin-top: 15px;
        border-radius: 20px;
        position: relative;
        width: 526px;

        @media screen and (max-width: 700px) {
            width: auto;
        }

        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 100px;

        .top_left {
            position: absolute;
            left: 10px;
            top: 9px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }

        .ColorBox {
            position: absolute;
            top: 16px;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 510px;
            height: 41px;
            background: #FFF7ED;
            border: 1px solid #FBBF24;
            box-sizing: border-box;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            @media screen and (max-width: 700px) {
                width: auto;
                height: fit-content;
                padding: 5px;
            }

            svg {
                width: 21px;
                height: 14px;
                margin-right: 13px;
            }

            div {
                font-family: Roboto;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                color: #9A3412;

                b {
                    font-weight: 600;
                }

                a {
                    font-weight: 600;
                    text-decoration: underline;
                    color: #9A3412;

                    &:hover {
                        color: #9A3412;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    form {
        width: 100%;

        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }

    .form-floating {
        margin-top: 20px;
    }

    h3 {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #212541;
    }

    p {
        margin-top: 7px;

        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;

        color: #9598A7;
    }

    .form-floating>label {
        padding: 22px 13px;

        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598A7;
    }

    input {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;

        color: #212541;

        border: 1px solid #DDE3E8;
        border-radius: 0;
    }

    label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0px;
        background: #C7D4EB;
        border-radius: 25px;
    }

    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #FFFFFF;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:focus {
            outline: 0;
        }

        &:after {
            content: "";
            position: absolute;
            top: 4px;
            left: 3px;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: white;
            box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
            transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
        }

        &:checked {
            border-color: #2ED8B6;
            background: #2ED8B6;
        }

        &:checked:after {
            transform: translatex(20px);

        }
    }

    .mobile_doba_inputs {
        display: grid !important;
    }

    .doba_inputs {
        background: white;
        padding: 20px;
        width: 100%;

        @media (max-width: 550px) {
            margin: 20px 0 !important;
        }

        .form-floating>label,
        .float-container label {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }

        input {
            height: 50px;
            border-radius: 0
        }

        textarea {
            border-radius: 0
        }
    }

    .info {
        position: absolute;
        top: 15px;
        right: 15px;
        margin-left: 8px;

        &:hover {
            .my_tooltip {
                opacity: 1;
            }
        }

        .info_icon {
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            float: right;

            svg {
                width: 20px;
                height: 20px;
            }
        }

        .my_tooltip {
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 250px;
            background: #F3385A;
            box-sizing: border-box;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            padding: 10px;
            position: absolute;
            bottom: 25px;
            right: -5px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;

            &::after {
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 8px;
                margin: auto;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }

    .agree_tooltip {
        position: relative;
    }

    .my_tooltip {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 300px;
        background: #F3385A;
        box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: unset;
        right: 15px;
        z-index: 10000;
        transition: opacity .5s ease-in-out;

        &::after {
            content: '';
            width: 15px;
            height: 15px;
            background: #F3385A;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }
</style>

</style>

</style>